import { Language } from '../context/LanguageContext';

interface WatchCardModalTranslations {
    title: string;
    description: string;
    serialLabel: string;
    pinLabel: string;
    serialPlaceholder: string;
    pinPlaceholder: string;
    downloadButton: string;
    downloadingButton: string;
    errorMessage: string;
    successMessage: string;
}

const watchCardModalTranslations: Record<Language, WatchCardModalTranslations> = {
    en: {
        title: "Download Watch Card",
        description: "Enter your watch serial number and PIN to download your authenticity certificate.",
        serialLabel: "Serial Number",
        pinLabel: "PIN",
        serialPlaceholder: "Enter serial number",
        pinPlaceholder: "Enter PIN",
        downloadButton: "Download Certificate",
        downloadingButton: "Downloading...",
        errorMessage: "Failed to download certificate. Please check your details and try again.",
        successMessage: "Certificate downloaded successfully!"
    },
    de: {
        title: "Uhrenzertifikat Herunterladen",
        description: "Geben Sie die Seriennummer und PIN Ihrer Uhr ein, um Ihr Authentizitätszertifikat herunterzuladen.",
        serialLabel: "Seriennummer",
        pinLabel: "PIN",
        serialPlaceholder: "Seriennummer eingeben",
        pinPlaceholder: "PIN eingeben",
        downloadButton: "Zertifikat Herunterladen",
        downloadingButton: "Wird heruntergeladen...",
        errorMessage: "Zertifikat konnte nicht heruntergeladen werden. Bitte überprüfen Sie Ihre Angaben und versuchen Sie es erneut.",
        successMessage: "Zertifikat erfolgreich heruntergeladen!"
    },
    fr: {
        title: "Télécharger la Carte de Montre",
        description: "Entrez le numéro de série et le PIN de votre montre pour télécharger votre certificat d'authenticité.",
        serialLabel: "Numéro de Série",
        pinLabel: "PIN",
        serialPlaceholder: "Entrer le numéro de série",
        pinPlaceholder: "Entrer le PIN",
        downloadButton: "Télécharger le Certificat",
        downloadingButton: "Téléchargement...",
        errorMessage: "Échec du téléchargement du certificat. Veuillez vérifier vos détails et réessayer.",
        successMessage: "Certificat téléchargé avec succès!"
    },
    zh: {
        title: "下载手表证书",
        description: "输入您手表的序列号和PIN码以下载真实性证书。",
        serialLabel: "序列号",
        pinLabel: "PIN码",
        serialPlaceholder: "输入序列号",
        pinPlaceholder: "输入PIN码",
        downloadButton: "下载证书",
        downloadingButton: "下载中...",
        errorMessage: "下载证书失败。请检查您的详细信息并重试。",
        successMessage: "证书下载成功！"
    }
};

export function getWatchCardModalTranslations(language: Language): WatchCardModalTranslations {
    return watchCardModalTranslations[language] || watchCardModalTranslations.en;
}

export type { WatchCardModalTranslations };